import React from 'react';
import PropTypes from 'prop-types';
// Custom
import { DisabledContext } from 'components/misc/Contexts';
import ResourcesSelectField from 'components/inputFields/ResourcesSelectField';
import { CloseIconButton } from 'components/buttons/IconButtons';

const ResourceSelectFieldFilter = ({
  labelId, resourceId, resources, displayKey, onChange,
}) => (
  <DisabledContext.Consumer>
    {(disabled) => (
      <ResourcesSelectField
        disabled={disabled}
        labelId={labelId}
        value={resourceId}
        resources={resources}
        displayKey={displayKey}
        withNullItem
        hideDropDownIcon={resourceId !== null}
        adornments={{
          end: resourceId !== null ? (
            <CloseIconButton onClick={() => onChange(null)} tooltipId="tooltip.empty" />) : null,
        }}
        onChange={onChange}
      />
    )}
  </DisabledContext.Consumer>
);

ResourceSelectFieldFilter.propTypes = {
  labelId: PropTypes.string.isRequired,
  resourceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  resources: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  })),
  displayKey: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
};

ResourceSelectFieldFilter.defaultProps = {
  resourceId: null,
  resources: null,
};

module.exports = ResourceSelectFieldFilter;



// WEBPACK FOOTER //
// ./components/filters/ResourceSelectFieldFilter.js